module.exports = __webpack_public_path__ + "img/sushilka_dlya_ruk.af16e987.svg";